<script src="https://static.line-scdn.net/liff/edge/2/sdk.js"></script>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
<link rel ="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"></link>
<template>
  <v-container>
    <v-layout text-center wrap>
      <span id="main_title">
        <span id="main_title_text"><h4>購入履歴</h4></span>
        </span>
        <span id="header_logo"><img src="https://misemeg.jp/appli/img/misemeg-logo.svg" width="49px" /></span>
        <span id="window_close" @click="returntop"><i class="fa fa-angle-double-left fa-3x fa-fw"
            title="TOP画面に戻る"></i></span>
        <!-- <v-flex xs6><span id="upper_btn_rireki"><i class="fa fa-list fa-lg"></i>&nbsp;購入履歴</span></v-flex>  -->
        <v-flex xs12><span id="upper_btn_receipt" @click="slip_viewer" title="電子レシートを表示します"><i
              class="fa fa-list-alt fa-lg"></i>&nbsp;電子レシート</span></v-flex>
        <v-flex xs12>
          <!-- <v-btn large color="success" @click="returntop" title="ＴＯＰ画面に戻る" id="returntop_btn">ＴＯＰ画面に戻る</v-btn> -->
          <!-- <v-btn large color="success" @click="slip_viewer" title="電子レシートを表示します" id="slip_viewer_btn">電子レシート</v-btn> -->
          <span id="purchases_info"></span>
          <!-- <span @click="slip_viewer" title="電子レシートを表示します" id="slip_viewer"><i class="fa fa-copy fa-lg"></i></span> -->
        </v-flex>
        <span id="misemeg_membercd" hidden></span>
        <!-- Snackbar -->
        <div>
          <v-snackbar v-model="snackbarFlag" color="primary" multi-line :timeout="snackbarTimeout" top>
            {{ snackbarText }}
          </v-snackbar>
        </div>
        <br />
        <br />
        <v-flex mb-4 xs12>
          <br /><br />
          <div class="ma-4">
            <span id="copyright"><a href="https://www.busicom.co.jp/product/misemeg/mini/?openExternalBrowser=1"
                target="_blank">&emsp;みせめぐ&nbsp;&times;&nbsp;LINEミニアプリ&emsp;<br />&emsp;Copyright &copy;
                BUSICOM.Co.,ltd. </a><br />&emsp;v2.5.0.1&emsp;</span>
          </div>
        </v-flex>
    </v-layout>
  </v-container>
</template>
<style>
.v-main{
  background-color:#f3f3f3;
  text-align: center;
}
#main_title {
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00843f;
  color: #ddd;
  width: 100%;
  height: 70px;
  letter-spacing: 0.3em;
  margin-top: -12px;
  margin-left: -12px;
  margin-right: -50px;
}
#main_title_text {
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.3em;
  margin-top: 0px;
  margin-left: -10px;
  margin-right: 0px;
}
#header_logo{
  height:70px;
  display:flex;
  justify-content: center;
  align-items: center;
  margin-top:-70px;
  margin-left:0px;
  margin-right:100px;
 }
 #returntop_btn{
  width:50%;
  font-size:large;
 }
 #upper_btn_rireki{
  display:flex;
  justify-content: center;
  align-items: center;
  width:100%;
  height:47px;
  margin:5px;
  font-size:middle;
  letter-spacing:0.3em;
  background-color: #DFFFF1;
  color: #003619;
 }
 #upper_btn_receipt{
  display:flex;
  justify-content: center;
  align-items: center;
  width:100%;
  height:47px;
  margin:5px;
  font-size:middle;
  letter-spacing:0.3em;
  background-color: #73FFC3;
  color: #003619;
 }
 #slip_viewer_btn{
  width:65%;
  font-size:large;
  letter-spacing:0.3em;
 }
 #slip_viewer{
    /* グリッド表示上に重ねて表示されるレシート表示ボタン */
    position: fixed;
    bottom: 10px;
    right: 10px;
    background-color: #00843f;
    color: #f3f3f3;
    padding: 10px;
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    cursor: pointer;
    z-index: 1000;
  }
    #window_close {
      margin-top: -58px;
      padding-left: 84%;
      color: #f3f3f3;
    }
 #buygoodshistory_tbl{
  margin: 0 auto;
  width: 100%;
  display: fixed;
  border-collapse:collapse;
  border:0px solid #000; 
  background-color:#fff;
 }
 #buygoodshistory_tbl tr{
  border-collapse:collapse;
  border-bottom:1px solid #00843f; 
 }
 #buygoodshistory_tbl td{
  border-collapse:collapse;
  border:0px solid #000; 
  text-align:left;
  min-width:100px;
 }
 .std_row{
  background-color:#f3f3f3;
 }
 .alt_row{
  background-color:#f3f3f3;
 }
 #line_logout{
  margin: 0 auto;
 }
 #copyright{
  margin: 0 auto;
  color:#88b3b3;
  text-decoration: none;
 }
 #copyright a{
  margin: 0 auto;
  color:#88b3b3;
  text-decoration: none;
 }
 .data_date{
  background-color : #00843f;
  color : #fff;
 }
 .data_qty{
  text-align : right;
 }
 .data_price{
  text-align : right;
 }
 hr {
    height: 3px;
    border: 0;
    border-color : #00843f;
    box-shadow: inset 0 12px 12px -12px rgba(168,168,168,0.7);
 }
</style>
<script>
// for encrypt message
import crypto from 'crypto-js';
var CryptoJS = require('crypto-js');
// var dts = new Date().getDate();
var dts = '651127';
var passPhrase = "45b54c392cc235a79ce573f623b2f8023" + dts + "d6dd6edf2488805962a3d223be6566b";
const salt = CryptoJS.lib.WordArray.random(128 / 8);
const iv = CryptoJS.lib.WordArray.random(128 / 8);
const key = "0921b90b3b7dab492b4aa897e3d0ccffde0f59579fc0c6229213c" + dts + "94822466ce8";
// for HTTP response
import axios from 'axios'

export default {
  data () {
    return {
      snackbarFlag: false,
      snackbarTimeout: 3000,
      snackbarText: '',
      name: '',
      imgURL: '',
      userId: '',
      email: '',
      barcode_url: '',
      inClient: false
    }
  },
  created () {
    this.initializeLiff();
    //window.alert('page loaded');
  },
  mounted () {
     $('#main_title').css('width',window.outerWidth);
  },
  methods: {
    
    initializeLiff: function () {
      var me = this
      liff.init(
        {
          liffId: process.env.VUE_APP_LIFF_ID
        },
        data => {
          me.loginCheck()
        },
        err => {
          console.log('LIFF initialization failed', err)
        }
      )
    },
    loginCheck: function () {
      var me = this
      //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
      var miseid=this.$_t_shopid();
      //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
      var debug_mode = this.$_debug_mode();
      if(debug_mode == '2'){
        miseid=this.$_shopid();
      }
              
      var encrypted_myshopid = localStorage.getItem('lmmini_' + dts + '_myshopid');
      if(encrypted_myshopid){
        const dec_encrypted_myshopid = CryptoJS.AES.decrypt(encrypted_myshopid, key, {iv: iv,});
        miseid = dec_encrypted_myshopid.toString(CryptoJS.enc.Utf8);
      }
      // window.alert('miseid:' + miseid);
      // 0016891 20240918 "liff init failure"エラーの対策で liff.ready の処理を追記
      liff.ready.then(() => {
        
      // ログインチェック      
      if (liff.isLoggedIn()) {
        this.isClient = liff.isInClient();
        const permissionStatus = liff.permission.query("email");
        debugger;
        if (permissionStatus.state === "prompt") {
            liff.permission.requestAll();
        }
         const idToken = liff.getDecodedIDToken();
         console.log(idToken); // print decoded idToken object
         //20241209
         var email = idToken.email;
        /*
        var encrypted_mail = localStorage.getItem('lmmini_' + dts + '_maddr');
        var dec_email = CryptoJS.AES.decrypt(encrypted_mail, key, {iv: iv,});
        var email = dec_email.toString(CryptoJS.enc.Utf8);
        */
       
       /**
        * みせめぐ会員証IDを取得する
        */
        // プロフィール取得
        liff.getProfile()
          .then(profile => {
            me.name = profile.displayName
            me.imgURL = profile.pictureUrl
            me.userId = profile.userId
            me.email = email            
            //me.barcode_img = barcode_url
            debugger;            
          })
          .catch((err) => {
            console.log('error', err)
          })
        // md5()実行用ライブラリ読込
        var md5 = require('md5');
        // tokenを当日のみ有効（最大24時間）とするため日付を求めてmmddyyyyにしておく(午前ゼロ時をまたいでエラーになるケースはいったん無視する）
        var dt = new Date();
        var year = dt.getFullYear();
        var month = dt.getMonth()+1;
        var strMonth='';
        if(month<10){
          strMonth = '0' + month;
        }else{
          strMonth = month.toString();
        }
        var date = dt.getDate();
        var strDate = '';
        if(date<10){
          strDate = '0' + date;
        }else{
          strDate = date.toString();
        }
        var mmddyyyy= strMonth + '-' + strDate + '-' + year;
        //オーナーIDをグローバル変数から取得する（※初期値は試験用）
        var ownerid=this.$_t_prmid();
        //デバッグモード=2（本番用）の場合のみ本番用オーナーIDで置換する 0015080
        var debug_mode = this.$_debug_mode();
        if(debug_mode == '2'){
          ownerid=this.$_prmid();
        }
        // （１）メルアドに対応するみせめぐユーザーIDを取得する（※すでにアプリでUIDを持っているか否かを判断するのに使用）
        var getuid_url ="";
        //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
        var i_shopid=Number(this.$_shopid());
        if(debug_mode=='0'){
          getuid_url = this.$_debug_url();
        }else if(debug_mode=='2'){
          if(i_shopid % 2 == 0){
            getuid_url = "https://sv2.misemeg.jp/";
          }else{
            getuid_url = "https://sv1.misemeg.jp/";
          }
        }else{
          if(i_shopid % 2 == 0){
            getuid_url = "https://sv2.misemegu.jp/";
          }else{
            getuid_url = "https://sv1.misemegu.jp/";
          }
        }
        getuid_url += "appli/line/";
        getuid_url += "getMisemegMEMBERCD.php?mail=";
        getuid_url += email;
        getuid_url += "&prmid=" + ownerid;
        getuid_url += "&security=" + md5(email + "5ca968c5c9c793ad75b49ac19b493ad2misemeg" + email + "!Busicom04510" + mmddyyyy);  
        // window.alert('getMisemegMEMBERCD.php = ' + getuid_url);     
        axios.get('getMisemegMEMBERCD.php = ' + getuid_url)
        .then((response) => document.getElementById('misemeg_membercd').innerHTML = response.data)
        .catch(error => console.log(error))
        ; 

        //----------------------------
        // 購買履歴情報の取得と表示
        //----------------------------
        /*
            // TenpoVisorURL=DB名（本番用）
            $tv_url: "actinolite",
            // TenpoVisorURL=DB名（試験用）
            $t_tv_url: "actinolite",
            // TenpoVisorURL=DB名（本番用）
            $tvdb_svr: "1",
            // TenpoVisorURL=DB名（試験用）
            $t_tvdb_svr: "11",
        */
        var svr_number = this.$_t_tvdb_svr();
        if(debug_mode != '0'){
          svr_number = this.$_tvdb_svr();
        }

        var tvurl = this.$_t_tv_url();
        if(debug_mode == '2'){
          tvurl = this.$_tvurl();
        }
        var codeinfo_url ="";
        debug_mode = this.$_debug_mode();
        //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
        var i_shopid=Number(this.$_shopid());
        if(debug_mode=='0'){
          codeinfo_url = this.$_debug_url();
        }else if(debug_mode=='2'){
          if(i_shopid % 2 == 0){
            codeinfo_url = "https://sv2.misemeg.jp/";
          }else{
            codeinfo_url = "https://sv1.misemeg.jp/";
          }
        }else{
          if(i_shopid % 2 == 0){
            codeinfo_url = "https://sv2.misemegu.jp/";
          }else{
            codeinfo_url = "https://sv1.misemegu.jp/";
          }
        }
        codeinfo_url += "appli/line/";
        codeinfo_url += "getBuyGoodsHistoryInfoHTML3receipt.php?mail=";
        codeinfo_url += email;
        codeinfo_url += "&prmid="
        codeinfo_url += ownerid;
        codeinfo_url += "&security=" + md5(email + "5ca968c5c9c793ad75b49ac19b493ad2misemeg" + email + "!Busicom04510" + mmddyyyy);  
        codeinfo_url += "&svr=" + btoa(svr_number);
        codeinfo_url += "&tvurl=" + btoa(tvurl);
        // window.alert('getBuyGoodsHistoryInfoHTML3receipt.php=' + codeinfo_url);     
        axios.get(codeinfo_url)
        //.then((response) => this.users = response.data)
        .then((response) => document.getElementById('purchases_info').innerHTML = response.data)
        .catch(error => console.log(error))
        ;        
        debugger;

      } else {
        // ログインまだ
        this.$router.push({ name: 'login' })
      }

      }); // end of liff.ready.then
    },
    logout: function () {
      // ログアウト
      if (liff.isLoggedIn()) {
        liff.logout()
        this.$router.push({ name: 'login' })
      }
    },
    returntop: function () {
      if (liff.isLoggedIn()) {
        // line-mini トップ画面に戻る      
        this.$router.push({ name: 'login' });
      }
    },
    slip_viewer: function () {
      // 電子レシート照会・表示ボタン
      var me = this
      // md5()実行用ライブラリ読込
      var md5 = require('md5');
      // host url
      var slip_url ="";
      var debug_mode = this.$_debug_mode();
      //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
      var i_shopid=Number(this.$_shopid());
      if(debug_mode=='0'){
        slip_url = this.$_debug_url();
      }else if(debug_mode=='2'){
        if(i_shopid % 2 == 0){
          slip_url = "https://sv2.misemeg.jp/";
        }else{
          slip_url = "https://sv1.misemeg.jp/";
        }
      }else{
        if(i_shopid % 2 == 0){
          slip_url = "https://sv2.misemegu.jp/";
        }else{
          slip_url = "https://sv1.misemegu.jp/";
        }
      }
      var svr_number = this.$_t_tvdb_svr();
      if(debug_mode != '0'){
        svr_number = this.$_tvdb_svr();
      }
      
      var tvurl = this.$_t_tv_url();
      if(debug_mode == '2'){
        tvurl = this.$_tvurl();
      }
      // for PC debug
      // slip_url = 'http://localhost/mg/appli/line/';
      // parameters生成
      //TenpoVisor会社コードをグローバル変数から取得する（※初期値は試験用）
      var tv_compcd = this.$_t_tv_compcd();
      //デバッグモード=2（本番用）の場合のみ本番用変数で置換する 0015080
      if(debug_mode == '2'){
        tv_compcd = this.$_tv_compcd();
      }
      //TenpoVisor会社コードをグローバル変数から取得する（※初期値は試験用）
      var tv_shopcd = this.$_t_tv_shopcd();
      //デバッグモード=2（本番用）の場合のみ本番用変数で置換する 0015080
      if(debug_mode == '2'){
        tv_shopcd = this.$_tv_shopcd();
      }
      var tv_custcd = document.getElementById('misemeg_membercd').innerHTML;
      if(tv_custcd.length === 0){
        var encrypted_membercd = localStorage.getItem('lmmini_' + dts + '_memcode');
        if(encrypted_membercd){
          const dec_encrypted_membercd = CryptoJS.AES.decrypt(encrypted_membercd, key, {iv: iv,});
          tv_custcd = dec_encrypted_membercd.toString(CryptoJS.enc.Utf8);
        }
      }
      var b64_tv_compcd = btoa(tv_compcd);
      var b64_tv_shopcd = btoa(tv_shopcd);
      var b64_tv_custcd = btoa(tv_custcd);
      var direction = "";
      // window.alert('tv_compcd=' + tv_compcd + ' tv_shopcd=' + tv_shopcd + ' tv_custcd=' + tv_custcd);
      //電子レシート表示用トークンは24時間制限無し（ハッシュ値照合OKであれば無期限）とする
      var security = md5(tv_compcd  + "5ca968c5c9c793ad75b49ac19b493ad2misemegLine" + tv_compcd  + "!Busicom04510");
      slip_url +="appli/line/";  
      slip_url += "receiptViewer2.php?tv_compcd=" + btoa(tv_compcd)  + "&tv_shopcd=" + btoa(tv_shopcd)  + "&tv_custcd=" + btoa(tv_custcd) + "&direction=" + direction + "&security=" + security;
      slip_url += "&svr=" + btoa(svr_number);
      slip_url += "&tvurl=" + btoa(tvurl);
      // 別ウィンドウで開く
      // window.alert('slip_url=' + slip_url);
      window.open(slip_url,'_blank');
    },
    showSnackbar(text) {
      this.snackbarFlag = true
      this.snackbarText = text
      setTimeout(()=> {
          this.snackbarFlag = false
          this.snackbarText = ''
        },
        this.snackbarTimeout
      )
    },
    getBarcodeParam(){
      md5()
    }
    
  }
}
</script>